var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"distribution",style:({'grid-template-columns': _vm.templateColumns})},_vm._l((_vm.distribution),function(column,index){return _c('div',{key:column + index,staticClass:"col"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }